import { usePlatformData } from "../hooks/usePlatformData";
import LabelEditor from "./LabelEditor";

export default function TagEditor({
  tags,
  onSave,
}: {
  tags: string[] | undefined;
  onSave: (tags: string[]) => Promise<void>;
}) {
  const platformData = usePlatformData();

  return (
    <>
      {/* Tag editing UI */}
      <div className="flex items-start gap-2 group">
        <label className="font-medium text-gray-700 dark:text-zinc-100">
          Tags:
        </label>
        <LabelEditor
          items={tags}
          autocomplete={platformData.tags.data?.tags}
          onSave={onSave}
        />
      </div>
    </>
  );
}
